// Константы для фильтров пользователей
export const USER_STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' }
];

// Константы для провайдеров пользователей
export const PROVIDER_OPTIONS = [
  { value: 'local', label: 'Local' },
  { value: 'google', label: 'Google' }
];

// Provider labels for display (создается из PROVIDER_OPTIONS)
export const PROVIDER_LABELS = PROVIDER_OPTIONS.reduce((acc, provider) => {
  acc[provider.value] = provider.label;
  return acc;
}, {});

// Константы для фильтров ролей
export const ROLE_STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' }
];

// Константы для типов ролей
export const ROLE_TYPE_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'system', label: 'System' },
  { value: 'custom', label: 'Custom' }
];

// Константы для фильтров разрешений
export const PERMISSION_STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' }
];

// Общие опции для пагинации
export const PAGINATION_OPTIONS = [5, 10, 25, 50];

// Общие настройки для фильтров
export const FILTER_CONFIG = {
  // Debounce delay для поиска и фильтров
  SEARCH_DEBOUNCE_DELAY: 300,
  DATE_DEBOUNCE_DELAY: 500,
  
  // Минимальная ширина для мультиселектов
  MULTISELECT_MIN_WIDTH: 200,
  
  // Высота полей ввода
  INPUT_HEIGHT: '40px',
  
  // Размеры кнопок
  BUTTON_SIZES: {
    small: 'small',
    medium: 'medium'
  }
};
